import { c as _c } from "react/compiler-runtime";
import { PatientDynamicFieldType } from "@/types/enums";
import PatientHealthFieldDialog from "./patient-health-field-dialog";
const FAMILY_HISTORY_CONFIG = {
  type: PatientDynamicFieldType.FAMILY_HISTORY,
  title: "Family History",
  description: "Add family medical history and hereditary conditions. Information from patient forms will appear here automatically.",
  placeholder: "e.g., Father - Diabetes",
  addButtonText: "Add family history",
  addAnotherButtonText: "Add another family history"
};
interface FamilyHistoryDialogProps {
  children?: React.ReactNode;
  patientId: string;
}
export default function FamilyHistoryDialog(t0) {
  const $ = _c(3);
  const {
    children,
    patientId
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== patientId) {
    t1 = <PatientHealthFieldDialog config={FAMILY_HISTORY_CONFIG} patientId={patientId}>{children}</PatientHealthFieldDialog>;
    $[0] = children;
    $[1] = patientId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}